export const sendMyaPatchRequest = async ({ body, messageId, conversationId, sessionToken, }) => {
    if (!(conversationId && messageId)) {
        return Promise.reject({
            success: false,
            error: 'Missing conversationId or messageId',
            status: null,
        });
    }
    // Mock response for development/testing (dev mode uses sessionToken like '123456')
    const isDevelopment = process.env.NODE_ENV === 'development' ||
        sessionToken.length < 10 ||
        conversationId === 123456 ||
        conversationId === '123456';
    if (isDevelopment) {
        console.log('[sendMyaPatchRequest] Using mocked response (status: 200)');
        // Simulate network delay
        await new Promise((resolve) => setTimeout(resolve, 300));
        return { success: true, status: 200 };
    }
    const requestUrl = `/mya/api/mya/conversations/${conversationId}/messages/${messageId}/update-message-meta-misc-fields/`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `JWT ${sessionToken}`,
    };
    try {
        const response = await fetch(requestUrl, {
            method: 'PATCH',
            headers,
            credentials: 'include',
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        return { success: true, status: response.status };
    }
    catch (err) {
        let errorMessage = 'An unknown error occurred';
        if (err instanceof Error) {
            errorMessage = err.message;
        }
        return { success: false, status: null, error: errorMessage };
    }
};
